import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { adaAccessRouter } from "./ada-access.router";
import { RulesSearchComponent } from "./rules/rules-search/rules-search/rules-search.component";
import { RulesCreateOrUpdateComponent } from "./rules/rules-create/rules-create/rules-create-or-update.component";
import { RiskScoreAuthoringComponent } from "./risk-score-authoring/risk-score-authoring.component";
import { RulesetCreateOrUpdateComponent } from "./ruleset/ruleset-create-or-update/ruleset-create-or-update.component";
import { RulesetSearchComponent } from "./ruleset/ruleset-search/ruleset-search.component";
import { AccessFlowSearchComponent } from "./access-flow-authoring/access-flow-search/access-flow-search.component";
import { AccessFlowCreateOrUpdateComponent } from "./access-flow-authoring/access-flow-create-or-update/access-flow-create-or-update.component";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
//import { AdaAccessAuthoringToolsComponent } from "./auth-tool-home/authoring-tools/ada-access-authoring-tools.component";
import { MatDialogModule } from "@angular/material/dialog";
import { AuthToolHomeComponent } from "./auth-tool-home/auth-tool-home.component";
import { AccessFlowRulesetCreateOrUpdateComponent } from "./access-flow-ruleset/access-flow-ruleset-create-or-update/access-flow-ruleset-create-or-update.component";
import { NodeUpdateComponent } from "./ruleset/node/node-update/node-update.component";
import { AacReportsComponent } from "./reports/aac-reports.component";
import { ProfileComponent } from "./shared/profile/profile.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { AacToolsComponent } from "./aac-tools/aac-tools.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AdaptiveAccessNodeSearchComponent } from "./adaptive-access-node/adaptive-access-node-search/adaptive-access-node-search.component";
import { AdaptiveAccessNodeCreateOrUpdateComponent } from "./adaptive-access-node/adaptive-access-node-create-or-update/adaptive-access-node-create-or-update.component";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import { MatTableModule } from "@angular/material/table";
import { AccessFlowNodePopupDialogComponent } from "./access-flow-authoring/access-flow-node-popup.component";
import { AdaptiveAccessNodeRulesetCreateOrUpdateDialogComponent} from "./adaptive-access-node-ruleset/adaptive-access-node-ruleset-create-or-update/adaptive-access-node-ruleset-create-or-update.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { SuccessDialogComponent } from "./shared/dialogs/success-dialog/success-dialog.component";
import { NodePopupComponent } from './ruleset/node-popup/node-popup.component';
import { NgChartsModule } from 'ng2-charts';
import { DeleteDialogComponent } from './shared/dialogs/delete-dialog/delete-dialog.component';
import { GenerateAccessFlowDialogComponent } from './access-flow-authoring/generate-access-flow-dialog/generate-access-flow-dialog.component';


@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CommonModule,
    RouterModule,
    adaAccessRouter,
    KeycloakAngularModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatTableModule,
    DragDropModule,
    NgChartsModule
  ],
  declarations: [
    RulesSearchComponent,
    RulesCreateOrUpdateComponent,
    RiskScoreAuthoringComponent,
    RulesetCreateOrUpdateComponent,
    RulesetSearchComponent,
    AccessFlowCreateOrUpdateComponent,
    AccessFlowSearchComponent,
   // AdaAccessAuthoringToolsComponent,
    AuthToolHomeComponent,
    AccessFlowRulesetCreateOrUpdateComponent,
    NodeUpdateComponent,
    AacReportsComponent,
    ProfileComponent,
    AacToolsComponent,
    AdaptiveAccessNodeSearchComponent,
    AdaptiveAccessNodeCreateOrUpdateComponent,
    AdaptiveAccessNodeRulesetCreateOrUpdateDialogComponent,
    SuccessDialogComponent,
    AccessFlowNodePopupDialogComponent,
    NodePopupComponent,
    DeleteDialogComponent,
    GenerateAccessFlowDialogComponent,
  ],
})
export class AdaAccessModule {}
